/* TradePro Article Table of Contents v1 */

(function () {
  function slugify(value) {
    return value
      .toString()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .substring(0, 80);
  }

  function initArticleToc() {
    document.querySelectorAll('[data-tradepro-article-page]').forEach(function (page) {
      var toc = page.querySelector('[data-tradepro-article-toc]');
      var tocList = page.querySelector('[data-tradepro-article-toc-list]');
      var content = page.querySelector('.tradepro-article-content');

      if (!toc || !tocList || !content) return;
      if (toc.dataset.tradeproTocReady === 'true') return;

      var headings = Array.prototype.slice.call(content.querySelectorAll('h2, h3'))
        .filter(function (heading) {
          return heading.textContent.trim().length > 0;
        });

      if (!headings.length) return;

      toc.dataset.tradeproTocReady = 'true';
      tocList.innerHTML = '';

      headings.forEach(function (heading, index) {
        var text = heading.textContent.trim();
        var id = heading.getAttribute('id');

        if (!id) {
          id = 'tradepro-article-section-' + slugify(text || index);
          heading.setAttribute('id', id);
        }

        var link = document.createElement('a');
        link.className = 'tradepro-article-toc__link tradepro-article-toc__link--' + heading.tagName.toLowerCase();
        link.href = '#' + id;
        link.textContent = text;

        tocList.appendChild(link);
      });

      toc.removeAttribute('hidden');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initArticleToc);
  } else {
    initArticleToc();
  }

  document.addEventListener('shopify:section:load', initArticleToc);
})();


/* Kitomasgota article progress + active TOC */
(function(){
  function initEditorialArticle(){document.querySelectorAll('[data-tradepro-article-page]').forEach(function(page){if(page.dataset.kmgEditorialReady==='true')return;page.dataset.kmgEditorialReady='true';var bar=page.querySelector('[data-tradepro-article-progress] span');var content=page.querySelector('.tradepro-article-content');var links=Array.prototype.slice.call(page.querySelectorAll('.tradepro-article-toc__link'));function update(){if(bar&&content){var rect=content.getBoundingClientRect();var total=Math.max(1,content.offsetHeight-window.innerHeight);var passed=Math.min(total,Math.max(0,-rect.top+120));bar.style.width=(passed/total*100)+'%'}var active=null;links.forEach(function(link){var id=decodeURIComponent(link.getAttribute('href').slice(1));var target=document.getElementById(id);if(target&&target.getBoundingClientRect().top<=170)active=link});links.forEach(function(link){link.classList.toggle('is-active',link===active)})}window.addEventListener('scroll',update,{passive:true});window.addEventListener('resize',update);setTimeout(update,50)})}if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initEditorialArticle)}else{initEditorialArticle()}document.addEventListener('shopify:section:load',initEditorialArticle)})();
